import { useState } from 'react';
import PropTypes from 'prop-types';
import { FiEye, FiEyeOff } from 'react-icons/fi';

/** Labeled text input with error slot (architecture.md §19). */
export function Input({ label, error, id, className = '', ...rest }) {
  const inputId = id || rest.name;
  const isPassword = rest.type === 'password';
  const [showPassword, setShowPassword] = useState(false);

  return (
    <label htmlFor={inputId} className="block relative">
      {label && <span className="mb-1 block text-sm font-medium text-slate-700">{label}</span>}
      <div className="relative">
        <input
          id={inputId}
          className={`w-full rounded-dc-sm border px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-brand-500 ${
            error ? 'border-red-400' : 'border-slate-400'
          } ${isPassword ? 'pr-10' : ''} ${className}`}
          {...rest}
          type={isPassword && showPassword ? 'text' : rest.type}
        />
        {isPassword && (
          <button
            type="button"
            className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600 focus:outline-none"
            onClick={(e) => { e.preventDefault(); setShowPassword(!showPassword); }}
            tabIndex="-1"
          >
            {showPassword ? <FiEyeOff size={18} /> : <FiEye size={18} />}
          </button>
        )}
      </div>
      {error && <span className="mt-1 block text-xs text-red-600">{error}</span>}
    </label>
  );
}

Input.propTypes = {
  label: PropTypes.string,
  error: PropTypes.string,
  id: PropTypes.string,
  className: PropTypes.string,
};
